import React from 'react';
import { Badge } from '../../ui/Badge';
import { AlertCircleIcon, CheckCircleIcon, ClockIcon, UsersIcon } from 'lucide-react';
interface LinkingStatusBadgeProps {
  status: 'linked' | 'no-exhibitor' | 'no-users' | 'pending-setup' | 'team';
  count?: number;
  onClick?: () => void;
}
export function LinkingStatusBadge({
  status,
  count,
  onClick
}: LinkingStatusBadgeProps) {
  const configs = {
    linked: {
      icon: CheckCircleIcon,
      text: 'Linked',
      variant: 'success' as const,
      className: 'cursor-default'
    },
    'no-exhibitor': {
      icon: AlertCircleIcon,
      text: 'No Exhibitor',
      variant: 'error' as const,
      className: 'cursor-pointer hover:bg-red-100'
    },
    'no-users': {
      icon: AlertCircleIcon,
      text: 'No Contact',
      variant: 'warning' as const,
      className: 'cursor-pointer hover:bg-yellow-100'
    },
    'pending-setup': {
      icon: ClockIcon,
      text: 'Pending Setup',
      variant: 'warning' as const,
      className: 'cursor-default'
    },
    team: {
      icon: UsersIcon,
      text: count ? `${count} Team Member${count > 1 ? 's' : ''}` : 'Team',
      variant: 'default' as const,
      className: 'cursor-pointer hover:bg-gray-100'
    }
  };
  const config = configs[status];
  const Icon = config.icon;
  return <button type="button" onClick={onClick} disabled={!onClick} className={`inline-flex items-center gap-1.5 ${config.className}`} data-id="element-3159">
      <Badge variant={config.variant} size="sm" data-id="element-3160">
        <Icon className="w-3 h-3" data-id="element-3161" />
        <span data-id="element-3162">{config.text}</span>
      </Badge>
    </button>;
}